import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  InputAdornment,
  TextField,
  Typography,
} from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import {
  DEFAULT_PARTNER_ACCEPT_AMOUNT,
  isPartnerAcceptAmountValid,
} from '../../utils/partnerAcceptPlans';

const PartnerSubscriptionPricingDialog = ({
  open,
  partnerName,
  initialAmount = DEFAULT_PARTNER_ACCEPT_AMOUNT,
  submitting = false,
  onClose,
  onConfirm,
}) => {
  const [amount, setAmount] = useState(initialAmount);

  useEffect(() => {
    if (open) {
      setAmount(
        isPartnerAcceptAmountValid(initialAmount)
          ? Number(initialAmount)
          : DEFAULT_PARTNER_ACCEPT_AMOUNT,
      );
    }
  }, [open, initialAmount]);

  const handleClose = () => {
    if (submitting) return;
    onClose?.();
  };

  const handleAmountChange = (event) => {
    const nextValue = event.target.value;
    setAmount(nextValue === '' ? '' : Number(nextValue));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!isPartnerAcceptAmountValid(amount)) return;
    onConfirm?.(Number(amount));
  };

  const isValid = isPartnerAcceptAmountValid(amount);

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs">
      <form onSubmit={handleSubmit}>
        <DialogTitle sx={{ fontWeight: 700, pb: 1 }}>Update portal fee</DialogTitle>
        <DialogContent sx={{ pt: 1 }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2, lineHeight: 1.6 }}>
            Update the monthly partner portal fee (AED) for{' '}
            <Box component="span" sx={{ fontWeight: 600, color: 'text.primary' }}>
              {partnerName || 'this partner'}
            </Box>
            . New checkouts use this amount; past payments stay unchanged.
          </Typography>

          <TextField
            label="Amount"
            type="number"
            fullWidth
            required
            autoFocus
            disabled={submitting}
            value={amount}
            onChange={handleAmountChange}
            inputProps={{ min: 0.01, step: 'any' }}
            InputProps={{
              endAdornment: <InputAdornment position="end">AED</InputAdornment>,
            }}
            helperText="Positive amount in AED / month"
          />
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2.5 }}>
          <Button onClick={handleClose} disabled={submitting} sx={{ textTransform: 'none' }}>
            Cancel
          </Button>
          <LoadingButton
            type="submit"
            variant="contained"
            color="primary"
            loading={submitting}
            disabled={!isValid}
            sx={{ textTransform: 'none', minWidth: 120 }}
          >
            Save amount
          </LoadingButton>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default PartnerSubscriptionPricingDialog;
